// extracted by mini-css-extract-plugin
export var contrastLow = "_2w-1";
export var externalLink = "_2w-2";
export var externalLinkIcon = "_2w-3";
export var link = "_2w-0";
export var linkLabel = "_2w-4";